import { Layout } from "@/components/layout/Layout";
import { BlogHero } from "@/components/blog/BlogHero";
import { BlogIntro } from "@/components/blog/BlogIntro";
import { BlogSEO } from "@/components/blog/BlogSEO";
import { ComparisonTable } from "@/components/blog/ComparisonTable";
import { ProblemSection } from "@/components/blog/ProblemSection";
import { RefoundSection } from "@/components/blog/RefoundSection";
import { CriteriaSection } from "@/components/blog/CriteriaSection";
import { VerdictSection } from "@/components/blog/VerdictSection";
import { RelatedArticles } from "@/components/blog/RelatedArticles";

const Blog = () => {
  return (
    <Layout>
      <BlogSEO />
      <BlogHero />
      <BlogIntro />
      <ComparisonTable />
      <ProblemSection />
      <RefoundSection />
      <CriteriaSection />
      <VerdictSection />
      <RelatedArticles currentSlug="meilleure-app-recu-2026" />
    </Layout>
  );
};

export default Blog;
